import { useLocale } from "@hooks/useLocale";
import { useCurrentWell } from "@hooks/useCurrentWell";
import { QueryState } from "@components/ui/QueryState";
import { CostPanel } from "./CostPanel";

/**
 * Cost & AFE screen — the standalone route. Resolves the current well's active
 * event and renders the plan-vs-actual + pivot panel (also embedded in the DDR
 * Cost tab).
 */
export function CostAfe() {
  const { t } = useLocale();
  const { well, activeEvent, isLoading, isError } = useCurrentWell();
  return (
    <div>
      <div className="page-head">
        <h1>{t("cost.title")}</h1>
        <p className="subtitle">{well ? `${well.commonName} · ${well.field}` : t("well.notSelected")}</p>
      </div>
      <QueryState
        isLoading={isLoading}
        isError={isError}
        isEmpty={!activeEvent}
        emptyMessage={t("well.event.noEvents")}
      >
        {activeEvent ? <CostPanel eventId={activeEvent.id} /> : null}
      </QueryState>
    </div>
  );
}
